"use client"

import { useState } from "react";
import UploadModal from "../shared/uploadModal";

export default function AllTools() {
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [titleText, setTitleText] = useState('');
    const [uploadbuttonText, setUploadButtonText] = useState('');
    const [uploadImage, setUploadImage] = useState('');
    const [fileTypes, setFileTypes] = useState<string[]>([]);

    function showTool(tool: string, index?: number) {
        const defaultUploadText = 'UPLOAD YOUR PDF';
        const toolItem = index !== undefined ? convertingTools[index] : null;
        
        setTitleText(toolItem?.uploadSubTitle || '');
        setUploadButtonText(toolItem?.uploadButtonText || defaultUploadText);
        setUploadImage(toolItem?.UploadImage || '');
        setFileTypes(toolItem?.uploadFileTypes || ['PDF']);
        setModalTitle(tool);
        setShowModal(true);
    }

    function uploadPdf() {
        setModalTitle('Upload PDF');
        setShowModal(true);
        setTitleText('');
        setUploadImage('');
        setUploadButtonText('UPLOAD YOUR PDF');
        setFileTypes(['PDF']);
    }

    function hideTool() {
        setShowModal(false);
    }

    const organizeTools = [
        {
            icon: '/img/edit-pdf-icon.svg',
            bgcolor: 'bg-slate-100',
            name: 'Edit PDF files',
            description: 'Edit PDF online Without converting Your Document',
            uploadFileTypes: ["PDF"]
        },
        {
            icon: '/img/merge-pdf.svg',
            bgcolor: 'bg-slate-100',
            name: 'Merge PDF Files',
            description: 'Combine Multiple documents to make a single PDF with ease',
            uploadFileTypes: ["PDF"]
        },
        {
            icon: '/img/merge-pdf.svg',
            bgcolor: 'bg-slate-100',
            name: 'Split PDF Files',
            description: 'Split and Extract PDF information into multiple files',
            uploadFileTypes: ["PDF"]
        },
        {
            icon: '/img/compress-pdf.svg',
            bgcolor: 'bg-slate-100',
            name: 'Compress PDF files',
            description: 'Efficiently Reduce PDF File Size while Maximizing Quality',
            uploadFileTypes: ["PDF"]
        },
        {
            icon: '/img/rotate-pdf.svg',
            bgcolor: 'bg-slate-100',
            name: 'Rotate PDF Files',
            description: 'Rotate One Several or all Pages of PDFs',
            uploadFileTypes: ["PDF"]
        },
        {
            icon: '/img/add-page-numbers.svg',
            bgcolor: 'bg-slate-100',
            name: 'Add Page Numbers',
            description: 'Easily insert page numbers into your PDF online',
            uploadFileTypes: ["PDF"]
        },
        {
            icon: '/img/delete-pdf-pages.svg',
            bgcolor: 'bg-slate-100',
            name: 'Delete PDF Pages',
            description: 'Remove PDF pages online and save result as new PDF',
            uploadFileTypes: ["PDF"]
        },
        {
            icon: '/img/add-watermark.svg',
            bgcolor: 'bg-slate-100',
            name: 'Add Watermark',
            description: 'Add Watermark Image or text to Your PDF Document',
            uploadFileTypes: ["PDF"]
        }
    ];

    const convertingTools = [
        {
            icon: '/img/convert-pdf-to-word.svg',
            bgcolor: 'bg-slate-100',
            name: 'Convert PDF to Word',
            uploadButtonText: "UPLOAD YOUR PDF"
        },
        {
            icon: '/img/convert-pdf-to-xls.svg',
            bgcolor: 'bg-slate-100',
            name: 'Convert PDF to Excel',
            uploadButtonText: "UPLOAD YOUR PDF"
        },
        {
            icon: '/img/convert-pdf-to-ppt.svg',
            bgcolor: 'bg-slate-100',
            name: 'Convert PDF to PowerPoint',
            uploadButtonText: "UPLOAD YOUR PDF"
        },
        {
            icon: '/img/convert-pdf-to-jpeg.svg',
            bgcolor: 'bg-slate-100',
            name: 'Convert PDF to JPG',
            uploadButtonText: "UPLOAD YOUR PDF"
        },
        {
            icon: '/img/convert-doc-to-pdf.svg',
            bgcolor: 'bg-slate-100',
            name: 'Convert Word to PDF',
            uploadSubTitle: "Drop Word Here",
            uploadButtonText: "UPLOAD YOUR WORD",
            UploadImage: "/img/doc-icon.svg",
            uploadFileTypes: ["DOC", "DOCX"]
        },
        {
            icon: '/img/convert-xls-to-pdf.svg',
            bgcolor: 'bg-slate-100',
            name: 'Convert Excel to PDF',
            uploadSubTitle: "Drop Excel Here",
            uploadButtonText: "UPLOAD YOUR EXCEL",
            UploadImage: "/img/excel-icon.svg",
            uploadFileTypes: ["XLS", "XLSX"]
        },
        {
            icon: '/img/convert-ppt-to-pdf.svg',
            bgcolor: 'bg-slate-100',
            name: 'Convert PowerPoint to PDF',
            uploadSubTitle: "Drop PPT Here",
            uploadButtonText: "UPLOAD YOUR PPT",
            UploadImage: "/img/ppt-icon.svg",
            uploadFileTypes: ["PPT", "PPTX"]
        },
        {
            icon: '/img/convert-jpeg-to-pdf.svg',
            bgcolor: 'bg-slate-100',
            name: 'Convert JPG to PDF',
            uploadSubTitle: "Drop JPG Here",
            uploadButtonText: "UPLOAD YOUR JPG",
            UploadImage: "/img/jpg-icon.svg",
            uploadFileTypes: ["JPG", "JPEG", "PNG"]
        },
    ];

    const creatingTools = [
        {
            icon: '/images/tools/split.svg',
            bgcolor: 'bg-slate-100',
            name: '',
            description: ''
        }
    ];

    const securityTools = [
        {
            icon: '/images/tools/split.svg',
            bgcolor: 'bg-slate-100',
            name: '',
            description: ''
        }
    ];

    return (
        <>
            <section className="tools section-gap">
                <div className="container">
                    <div className="tools__wrapper">
                        <div className="content-box">
                            <h2 className="secondary-heading text-center mb-300 mb-lg-500">Access To All Our Tools</h2>
                        </div>

                        <h3 className="secondary-heading mb-3">Editing Tools</h3>
                        <div className="grid grid--md-3 grid--lg-4 grid--2 gap-md-250 gap-150">
                            {organizeTools.map((tool: any, index: number) => (
                                <div className="" key={tool.name}>
                                    <a onClick={() => showTool(tool.name)}>
                                        <div className="tools__box box-shadow box">
                                            <img className="img-fluid tools__img" src={tool.icon} alt={tool.name} />
                                            <p className="secondary-desc text-center">{tool.name}</p>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>

                        <h3 className="secondary-heading mb-4 mt-300 mt-lg-600">Converter Tools</h3>
                        <div className="grid grid--md-3 grid--lg-4 grid--2 gap-md-250 gap-150">
                            {convertingTools.map((tool: any, index: number) => (
                                <div className="" key={tool.name}>
                                    <a onClick={() => showTool(tool.name, index)}>
                                        <div className="tools__box box-shadow box">
                                            <img className="img-fluid" src={tool.icon} alt={tool.name} />
                                            <p className="secondary-desc text-center">{tool.name}</p>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>

                        <div className="text-center mt-300 mt-lg-450">
                            <button className="mybtn mybtn--primary mybtn--bg px-500" onClick={() => uploadPdf()}>EXPLORE MORE TOOLS</button>
                        </div>
                    </div>
                </div>
            </section>

            <UploadModal
                title={modalTitle}
                subtitle={titleText}
                open={showModal}
                image={uploadImage}
                onClose={hideTool}
                fileTypes={fileTypes}
                buttonText={uploadbuttonText}
                multiple={true}
            />
        </>
    );
}